import { createSelector, createSlice, PayloadAction } from '@reduxjs/toolkit'

import { RootState } from '@/redux/store'
import { OnboardingChecklistItem } from '@/types/responses/onboarding-checklists'

export interface OnboardingChecklistState {
  checklist: OnboardingChecklistItem | null
}

const INITIAL_STATE: OnboardingChecklistState = {
  checklist: null,
}

export type OnboardingChecklistStep =
  | 'inviteTeam'
  | 'exploreCompass'
  | 'addRelationship'
  | 'uploadHistoricalReferrals'
  | 'makeReferral'
  | 'outlook'
  | 'emailAndCalendarIntegration'
  | 'completeProfile'

const onboardingChecklist = createSlice({
  name: 'onboardingChecklist',
  initialState: INITIAL_STATE,
  reducers: {
    setOnboardingChecklist(
      state,
      action: PayloadAction<OnboardingChecklistState['checklist']>,
    ) {
      state.checklist = action.payload
    },
  },
})

export const { setOnboardingChecklist } = onboardingChecklist.actions

export const selectOnboardingChecklistSlice = (state: RootState) =>
  state.onboardingChecklist

export const selectOnboardingChecklist = createSelector(
  selectOnboardingChecklistSlice,
  (state) => state.checklist,
)

export const onboardingChecklistReducer = onboardingChecklist.reducer

export const ONBOARDING_CHECKLIST_STEP: Record<
  OnboardingChecklistStep,
  OnboardingChecklistStep
> = {
  emailAndCalendarIntegration: 'emailAndCalendarIntegration',
  inviteTeam: 'inviteTeam',
  exploreCompass: 'exploreCompass',
  addRelationship: 'addRelationship',
  uploadHistoricalReferrals: 'uploadHistoricalReferrals',
  makeReferral: 'makeReferral',
  outlook: 'outlook',
  completeProfile: 'completeProfile',
}
